<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">{{ $t(titulo) }}</h1>

        <form @submit.prevent="submit" ref="addItem">
            <!--Bloco Responsável Familiar-->
            <div class="row">
                <form-select
                    v-model="acompanhamento.servico_id"
                    label="Serviço"
                    grid="6"
                    :itens="servicos"
                    :required="true"
                    :loading="loadingServicos"
                    :disabled="loadingServicos"
                />
                <form-select
                    v-model="acompanhamento.tecnico_id"
                    label="Técnico de referência"
                    :required="true"
                    grid="6"
                    :itens="tecnicos"
                    :loading="loadingTecnicos"
                    :disabled="loadingTecnicos"
                />

                <form-calendar
                    v-model="acompanhamento.data_ingresso"
                    grid="3"
                    label="Data de início"
                    :required="true"
                />

                <form-calendar
                    v-model="acompanhamento.data_final"
                    grid="3"
                    label="Data Final"
                />

                <form-calendar
                    v-model="acompanhamento.data_avaliacao"
                    grid="3"
                    label="Data Avaliação"
                    :required="true"
                />

                <form-select
                    v-model="acompanhamento.periodicidade"
                    label="Periodicidade"
                    grid="3"
                    :itens="$root.arrays.acompanhamento_periodicidade"
                    :required="true"
                />

                <form-select
                    v-model="acompanhamento.vulnerabilidades"
                    label="Vulnerabilidades"
                    :multiple="true"
                    :itens="vulnerabilidades"
                    grid="12"
                    :loading="loadingVulnerabilidades"
                    :disabled="loadingVulnerabilidades"
                />

                <form-select
                    v-model="acompanhamento.violencias"
                    label="Violência/Violações de direito"
                    :multiple="true"
                    :itens="violencias"
                    grid="12"
                    :loading="loadingViolencias"
                    :disabled="loadingViolencias"
                />

                <form-select
                    v-model="acompanhamento.pessoas"
                    :multiple="true"
                    label="Usuário(s)"
                    :itens="pessoas"
                    :required="true"
                />

            </div>
            <div class="row pt-4 px-0 d-flex justify-content-end">
                <form-toggle
                    grid="2"
                    class="mt-2"
                    v-model="acompanhamento.privado"
                    label="Sigilo?"
                />
                <div class="col-auto px-2 text-right ml-4">
                    <a class="btn btn-default" @click="$emit('voltar')">
                        <i class="mdi mdi-arrow-left" />
                    </a>
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    props: ["familia"],
    name: "Add",
    data() {
        return {
            acompanhamento: {},
            vulnerabilidades: {},
            violencias: {},
            tecnicos: [],
            tipos: [],
            servicos: [],
            files: [],
            progressCompleted: 0,
            titulo: "Iniciar Acompanhamento Familiar",
            loadingTecnicos: false,
            loadingServicos: false,
            loadingVulnerabilidades: false,
            loadingViolencias: false,
        };
    },
    mounted() {
        this.getTecnicos();
        this.getServicos();
        this.getVulnerabilidades();
        this.getViolencias();
        // this.privateFromOsasco();
    },
    computed: {
    pessoas() {
        let pessoas = this.familia.familiares;
        pessoas = pessoas.filter((elem) => {
            return elem.estado_cadastral_cadunico <= 3;
        });
        const map = pessoas.map((elem) => ({
            id: elem.id,
            value: elem.nome_social
            ? elem.nome_social + " <b>" + elem.idade + " ano(s)</b>"
            : elem.nome_completo + " <b>" + elem.idade + " ano(s)</b>",
        }));
        return map;
    },
    },
    methods: {
        // privateFromOsasco() {
        //   const role_name = this.$store.state.user.role_details.name;
        
        //     if (window.location.hostname == "osascosp.suasfacil.com.br" || window.location.hostname == 'suasfacil.host'|| window.location.hostname == 'sandbox.suasfacil.com.br' && role_name == 'Técnico(a) de Nível Superior') {
        //         this.acompanhamento.privado =  1;
        //     } else {
        //         this.acompanhamento.privado =  2;
        //     }
        // },
        async getTecnicos() {
            this.loadingTecnicos = true;
            await axios.get(`api/dashboard/tecnicos/get`).then((response) => {
                this.tecnicos = response.data;
                this.loadingTecnicos = false;
            });
        },
        async getVulnerabilidades() {
            this.loadingVulnerabilidades = true;
            await axios
                .get(`api/dashboard/get/vulnerabilidades`)
                .then((response) => {
                    this.vulnerabilidades = response.data;
                    this.loadingVulnerabilidades = false;
                });
        },
        async getViolencias() {
            this.loadingViolencias = true;
            await axios.get(`api/dashboard/get/violencias`).then((response) => {
                this.violencias = response.data;
                this.loadingViolencias = false;
            });
        },
        async getServicos() {
            this.loadingServicos = true;
            await axios
                .get(`api/dashboard/acompanhamento/servicos`)
                .then((response) => {
                    this.servicos = response.data;
                    this.loadingServicos = false;
                });
        },
        submit() {
            this.acompanhamento.familia_id = this.$route.params.id;
            this.$route.query.familia_id = this.$route.params.id;
            
            let formData = new FormData();
            for (var key in this.acompanhamento) {
                formData.append(key, this.acompanhamento[key]);
            }
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            axios
                .post(`api/dashboard/acompanhamentos`, formData)
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: "Acompanhamento cadastrado com sucesso.",
                    });
                    this.$router.push(
                        `/dashboard/acompanhamento/edit/${response.data.id}`
                    );
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                });
        },
    },
};
</script>
